// ══════════════════════════════════════════════════════════════
// COMPASS – Fund Reducer
// ══════════════════════════════════════════════════════════════
import { createReducer, on } from '@ngrx/store';
import { FundActions } from './fund.actions';
import { initialFundState, FundState } from './fund.state';

export const fundReducer = createReducer<FundState>(
  initialFundState,

  // Load Funds
  on(FundActions.loadFunds, (state): FundState => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(FundActions.loadFundsSuccess, (state, { funds }): FundState => ({
    ...state,
    funds,
    loading: false,
    error: null,
  })),

  on(FundActions.loadFundsFailure, (state, { error }): FundState => ({
    ...state,
    loading: false,
    error,
  })),

  // Load Single Fund
  on(FundActions.loadFund, (state): FundState => ({
    ...state,
    loading: true,
    selectedFund: null,
    error: null,
  })),

  on(FundActions.loadFundSuccess, (state, { fund }): FundState => ({
    ...state,
    selectedFund: fund,
    loading: false,
    error: null,
  })),

  on(FundActions.loadFundFailure, (state, { error }): FundState => ({
    ...state,
    loading: false,
    error,
  })),

  // Create Fund
  on(FundActions.createFund, (state): FundState => ({
    ...state,
    saving: true,
    error: null,
  })),

  on(FundActions.createFundSuccess, (state, { fund }): FundState => ({
    ...state,
    funds: [...state.funds, fund],
    saving: false,
    error: null,
  })),

  on(FundActions.createFundFailure, (state, { error }): FundState => ({
    ...state,
    saving: false,
    error,
  })),

  // Update Fund
  on(FundActions.updateFund, (state): FundState => ({
    ...state,
    saving: true,
    error: null,
  })),

  on(FundActions.updateFundSuccess, (state, { fund }): FundState => ({
    ...state,
    funds: state.funds.map((f) => (f.id === fund.id ? fund : f)),
    selectedFund: fund,
    saving: false,
    error: null,
  })),

  on(FundActions.updateFundFailure, (state, { error }): FundState => ({
    ...state,
    saving: false,
    error,
  })),

  // Delete Fund
  on(FundActions.deleteFund, (state): FundState => ({
    ...state,
    error: null,
  })),

  on(FundActions.deleteFundSuccess, (state, { fundId }): FundState => ({
    ...state,
    funds: state.funds.filter((f) => f.id !== fundId),
    error: null,
  })),

  on(FundActions.deleteFundFailure, (state, { error }): FundState => ({
    ...state,
    error,
  })),

  // Clear
  on(FundActions.clearFunds, (): FundState => ({
    ...initialFundState,
  })),
);
